import { render, staticRenderFns } from "./CSVExporter.vue?vue&type=template&id=63dafd98&"
import script from "./CSVExporter.vue?vue&type=script&lang=js&"
export * from "./CSVExporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports